import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { GTM_Select_Item } from '../../analytics/GoogleTagManager';
import { RecordlogEvents } from '../../analytics/RecordEvents';
import { redirecturl } from '../../services/common/redirect';
import { useSelector } from 'react-redux';

function CardDLS({ data }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const logintype = useSelector((state) => state?.userdata?.value?.loginmode);
  const userdata = useSelector(
    (state) => state?.userdata?.value?.rnuserdetails
  );

  console.log('data==>', data);
  const handleGTLRedirect = (e, url, title) => {
    try {
      GTM_Select_Item(data, 'GTL');
    } catch {}
    e.preventDefault();
    try {
      RecordlogEvents('GTL', {
        'Product Viewed': title,
        'Mobile Number': userdata?.msisdn,
        Status: 'Success',
        'Status Description': 'Success',
        'Login Type': logintype,
        Channel: 'WEBPORTAL',
      });
    } catch {}

    if (url?.indexOf('http') >= 0) {
      window.open(url, '_blank');
      return false;
    } else {
      //e.preventDefault();
      redirecturl(url, navigate);
    }
  };

  return (
    <div
      class="dls13_card_style3  flex-column card_style_2 height_100 align-item-center"
      onClick={(e) => {
        handleGTLRedirect(e, data?.buyurl, data?.title);
      }}
    >
      {data?.ribbonenable === 'T' && (
        <div
          class="offer-tag"
          style={{
            background: data?.ribbonbgcolor,
            color: data?.ribbontitlecolor,
          }}
        >
          {data?.ribbontitle}
        </div>
      )}

      <div class="com-wl w-100">
        <div class="sec001">
          <div class="card_img">
            <img src={data?.imagepath} alt="" />
          </div>
          <div class="card_info">
            <div class="card_info_grp">
              <h4> {data?.title} </h4>
            </div>
            <p class="mt-2">{data?.description}</p>
          </div>
        </div>
      </div>

      <div class="card_link flex_grp_align_center com-wr">
        <a href="#" class="hyperlink">
            {
                data?.discountprice > 0 ? `${t('kd')} ${data?.discountprice}` : `${t('kd')} ${data?.amount}`
            }
          {/* <span> / 30 Day </span> */}
        </a>
      </div>
    </div>
  );
}

export default CardDLS;
